/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ClosedEnum } from "../types/enums.js";

/**
 * （可选）指定图片主类别。
 *
 * @remarks
 *
 * **支持的主类别：**
 * - `acg`（二次元动漫，UapiPro服务器）
 * - `landscape`（风景图，外部图床）
 * - `anime`（混合动漫）
 * - `pc_wallpaper`（电脑壁纸，外部图床）
 * - `mobile_wallpaper`（手机壁纸，外部图床）
 * - `general_anime`（动漫图，外部图床）
 * - `ai_drawing`（AI绘画，外部图床）
 * - `bq`（表情包/趣图，UapiPro服务器）
 * - `furry`（福瑞，UapiPro服务器）
 *
 * > [!TIP]
 * > 如果不指定，将从所有图片中随机抽取（不包含 `ikun` 和 `ai_drawing`）。
 */
export const GetRandomImageCategory = {
  Acg: "acg",
  Landscape: "landscape",
  Anime: "anime",
  PcWallpaper: "pc_wallpaper",
  MobileWallpaper: "mobile_wallpaper",
  GeneralAnime: "general_anime",
  AiDrawing: "ai_drawing",
  Bq: "bq",
  Furry: "furry",
} as const;
/**
 * （可选）指定图片主类别。
 *
 * @remarks
 *
 * **支持的主类别：**
 * - `acg`（二次元动漫，UapiPro服务器）
 * - `landscape`（风景图，外部图床）
 * - `anime`（混合动漫）
 * - `pc_wallpaper`（电脑壁纸，外部图床）
 * - `mobile_wallpaper`（手机壁纸，外部图床）
 * - `general_anime`（动漫图，外部图床）
 * - `ai_drawing`（AI绘画，外部图床）
 * - `bq`（表情包/趣图，UapiPro服务器）
 * - `furry`（福瑞，UapiPro服务器）
 *
 * > [!TIP]
 * > 如果不指定，将从所有图片中随机抽取（不包含 `ikun` 和 `ai_drawing`）。
 */
export type GetRandomImageCategory = ClosedEnum<typeof GetRandomImageCategory>;

export const GetRandomImageCategory$zodSchema = z.enum([
  "acg",
  "landscape",
  "anime",
  "pc_wallpaper",
  "mobile_wallpaper",
  "general_anime",
  "ai_drawing",
  "bq",
  "furry",
]).describe(
  "（可选）指定图片主类别。\n\n**支持的主类别：**\n- `acg`（二次元动漫，UapiPro服务器）\n- `landscape`（风景图，外部图床）\n- `anime`（混合动漫）\n- `pc_wallpaper`（电脑壁纸，外部图床）\n- `mobile_wallpaper`（手机壁纸，外部图床）\n- `general_anime`（动漫图，外部图床）\n- `ai_drawing`（AI绘画，外部图床）\n- `bq`（表情包/趣图，UapiPro服务器）\n- `furry`（福瑞，UapiPro服务器）\n\n> [!TIP]\n> 如果不指定，将从所有图片中随机抽取（不包含 `ikun` 和 `ai_drawing`）。\n",
);

/**
 * （可选，仅UapiPro服务器图片支持）指定图片子类别。
 *
 * @remarks
 *
 * - **bq**: `xiongmao`, `waiguoren`, `maomao`, `ikun`, `eciyuan`
 * - **acg**: `pc`, `mb`
 * - **furry**: `z4k`, `szs8k`, `s4k`, `4k`
 *
 * > [!TIP]
 * > 外部图床类别和 `anime` 混合类别不支持 `type` 参数。
 */
export const GetRandomImageType = {
  Pc: "pc",
  Mb: "mb",
  Eciyuan: "eciyuan",
  Ikun: "ikun",
  Fourk: "4k",
  S4k: "s4k",
  Z4k: "z4k",
  Szs8k: "szs8k",
  Xiongmao: "xiongmao",
  Maomao: "maomao",
  Waiguoren: "waiguoren",
} as const;
/**
 * （可选，仅UapiPro服务器图片支持）指定图片子类别。
 *
 * @remarks
 *
 * - **bq**: `xiongmao`, `waiguoren`, `maomao`, `ikun`, `eciyuan`
 * - **acg**: `pc`, `mb`
 * - **furry**: `z4k`, `szs8k`, `s4k`, `4k`
 *
 * > [!TIP]
 * > 外部图床类别和 `anime` 混合类别不支持 `type` 参数。
 */
export type GetRandomImageType = ClosedEnum<typeof GetRandomImageType>;

export const GetRandomImageType$zodSchema = z.enum([
  "pc",
  "mb",
  "eciyuan",
  "ikun",
  "4k",
  "s4k",
  "z4k",
  "szs8k",
  "xiongmao",
  "maomao",
  "waiguoren",
]).describe(
  "（可选，仅UapiPro服务器图片支持）指定图片子类别。\n\n- **bq**: `xiongmao`, `waiguoren`, `maomao`, `ikun`, `eciyuan`\n- **acg**: `pc`, `mb`\n- **furry**: `z4k`, `szs8k`, `s4k`, `4k`\n\n> [!TIP]\n> 外部图床类别和 `anime` 混合类别不支持 `type` 参数。\n",
);

export type GetRandomImageRequest = {
  category?: GetRandomImageCategory | undefined;
  type?: GetRandomImageType | undefined;
};

export const GetRandomImageRequest$zodSchema: z.ZodType<GetRandomImageRequest> =
  z.object({
    category: GetRandomImageCategory$zodSchema.optional(),
    type: GetRandomImageType$zodSchema.optional(),
  });

/**
 * 服务器内部错误。
 */
export type GetRandomImageInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetRandomImageInternalServerErrorResponseBody$zodSchema: z.ZodType<
  GetRandomImageInternalServerErrorResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("服务器内部错误。");

/**
 * 未找到指定类别的图片。
 */
export type GetRandomImageNotFoundResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetRandomImageNotFoundResponseBody$zodSchema: z.ZodType<
  GetRandomImageNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("未找到指定类别的图片。");

export type GetRandomImageResponse =
  | Uint8Array
  | string
  | GetRandomImageNotFoundResponseBody
  | GetRandomImageInternalServerErrorResponseBody;

export const GetRandomImageResponse$zodSchema: z.ZodType<
  GetRandomImageResponse
> = z.union([
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.lazy(() => GetRandomImageNotFoundResponseBody$zodSchema),
  z.lazy(() => GetRandomImageInternalServerErrorResponseBody$zodSchema),
]);
